<template>
  <div class="vue-outer-wrap-create-utility">
    <div v-if="user" class="create-utility-container">
      <span
      v-if="successMessage"
      v-bind:class="{fade: fadeSuccessMessage}"
      class="success-message">&#10004;  {{successMessage}}</span>
      <span
      v-if="errorMessage"
      v-bind:class="{fade: fadeErrorMessage}"
      class="error-message">{{errorMessage}}</span>
      <div class="header">Create Utility</div>
        <div class="controls-container">
          <!-- name -->
          <div class="control-container">
            <div class="control utility-name">
              <label for="utility">Name:</label>
              <input ref="newUtilityName" v-model="newUtility.name" placeholder="Utility name" type="text" class="name" v-bind:disabled="updatingUtiity" @keyup="onNewUtilityNameChange($event)">
            </div>
          </div>
          <!-- code -->
          <div class="control-container">
            <div class="control utility-code">
              <label for="utility">Code:</label>
              <input v-model="newUtility.code" placeholder="Utility code" type="text" class="code" v-bind:disabled="updatingUtiity">
            </div>
          </div>
          <!-- description -->
          <div class="control-container">
            <div class="control utility-description">
              <label for="utility">Description:</label>
              <input v-model="newUtility.description" placeholder="Utility description" type="text" class="description" v-bind:disabled="updatingUtiity">
            </div>
          </div>
          <!-- url -->
          <div class="control-container">
            <div class="control utility-description">
              <label for="utility">Url:</label>
              <input v-model="newUtility.url" placeholder="Utility url" type="text" class="url" v-bind:disabled="updatingUtiity">
            </div>
          </div>
          <!-- utility type id -->
          <div class="control-container">
            <div class="control utility-type">
              <label for="utility">Utility type:</label>
              <select v-model="newUtility.utilityTypeId" @change="onUtilityTypeSelectChange($event)" name="utilites">
              <option v-for="utilityType in utilityTypes" :key="utilityType.utilityTypeId" :value="utilityType.utilityTypeId">{{utilityType.name}}</option>
              </select>
            </div>
          </div>
          <div class="buttons-container">
            <b-spinner v-if="updatingUtiity" class="ajax-spinner"></b-spinner>
            <b-button v-on:click="cancelUtilityEdit()" v-bind:disabled="updatingUtiity" class="cancel">Cancel</b-button>
            <b-button v-on:click="submitUtility()" v-bind:disabled="updatingUtiity || !newUtility.name || !newUtility.code" class="submit">Create Utility</b-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Auth } from 'aws-amplify';
import API from "@/services/api";
import lodash from 'lodash';

export default {
  name: 'CreateUtilityForm',
  props: {
    hideForm: Function,
    utilityCreated: Function
  },
  data() {
    return {
      user: undefined,
      updatingUtiity: false,
      successMessage: false,
      errorMessage: false,
      fadeSuccessMessage: false,
      fadeErrorMessage: false,
      newUtility: {},
      placeholderUtility: {name: ''},
      utilityTypes: []
    }
  },
  async created() {
    await this.getAllUtilityTypes();
    this.newUtility.utilityTypeId = this.utilityTypes[0].utilityTypeId;
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(user => {
          this.user = user;
      })
      .catch(() => console.log('not signed in...'))
  },
  methods: {
    cancelUtilityEdit(){
      this.hideForm();
    },
    showForm(){
      this.newUtility = {utilityTypeId: this.utilityTypes[0].utilityTypeId};
    },
    onPlaceholderUtilityNameChange (event) {
      this.showForm();
      this.newUtility.name = event.target.value;
      Vue.nextTick(() => this.$refs.newUtilityName.focus());
    },
    onNewUtilityNameChange (event) {
      if (!event.target.value || !event.target.value.length) {
        this.cancelUtilityEdit();
      }
    },
    async getAllUtilityTypes() {
      const utilityTypes = await API.GetUtilityTypes();

      if (utilityTypes && utilityTypes.length) {
        this.utilityTypes = utilityTypes;
      }
    },
    onUtilityTypeSelectChange(event) {
      const matchingUtilityType = lodash.find(this.utilityTypes, utilityType => utilityType.utilityTypeId === parseInt(event.target.value));
      this.selectedUtilityType = matchingUtilityType ? matchingUtilityType : undefined;

      if (this.selectedUtilityType) {
        this.newUtility.utilityTypeId = this.selectedUtilityType.utilityTypeId;
      }
    },
    submitUtility(){
      this.updatingUtiity = true;

      const postData = {
        isActive: true,
        name: this.newUtility.name,
        code: this.newUtility.code,
        description: this.newUtility.description,
        url: this.newUtility.url,
        utilityTypeId: this.newUtility.utilityTypeId
      };

      try {
        API.CreateUtility(postData).then((data) => {
          this.utilityCreated(data);
          this.updatingUtiity = false;
          this.successMessage = `${data.name} utility created`;
          this.hideForm();

          setTimeout(() => {this.fadeSuccessMessage = true}, 3000);
          setTimeout(() => {
            this.successMessage = '';
            this.fadeSuccessMessage = false;
          }, 6000);
        }, err => {
          console.error('CreateUtility - ERROR');
          console.dir(err);

          this.updatingUtiity = false;

          if (err
          && err.response
          && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
              this.errorMessage = `Error updating ${this.newUtility.name}`;
          }

          setTimeout(() => {this.fadeErrorMessage = true}, 3000);
          setTimeout(() => {
            this.errorMessage = '';
            this.fadeErrorMessage = false;
          }, 6000);
        })
      } catch (err) {
          this.updatingUtiity = false;
          console.error('POST ERROR!');
          console.dir(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .vue-outer-wrap-create-utility{
    .create-utility-container{
      position: relative;
      width: 100%;
      margin: 0 auto 20px;

      input[type="text"] {
        width: 100%;
      }

      .placeholder{
        height: 10px;
        background-color: #002D68;
        border: none;
      }

      .b-icon{
        position: absolute;
        top: 0;
        right: 0;
        font-weight: bold;
        color: #002D68;
        font-size: 28px;
      }

      .utility-name{
        color: #333;
      }

      .success-message{
        position: absolute;
        top: 0;
        right: 23px;
        font-weight: bold;
        color: #196319;
        -webkit-transition: all 2s ease-in-out;
        -moz-transition: all 2s ease-in-out;
        -o-transition: all 2s ease-in-out;
        transition: all 2s ease-in-out;

        &.fade {
            opacity: 0;
        }
      }

      .error-message{
        position: absolute;
        top: 0;
        right: 23px;
        font-size: 18px;
        font-weight: bold;
        color: #800000;
        -webkit-transition: all 2s ease-in-out;
        -moz-transition: all 2s ease-in-out;
        -o-transition: all 2s ease-in-out;
        transition: all 2s ease-in-out;

        &.fade {
            opacity: 0;
        }
      }

      .header{
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 22px;
        color: #002D68;
      }

      .controls-container {
        margin-bottom: 10px;
        padding: 10px 5px 20px 5px;
        background-color: #ededed;

        &.utility-select{
          select{
            margin-left: 5px; 
          } 
        }

        .control-container{
          margin: 20px 0;
        }

        label {
          margin-right: 10px;
          font-weight: bold;
        }
      }

      .buttons-container{
        padding: 10px;

        .ajax-spinner{
          position: relative;
          top: 6px;
          right:15px;
          color: #fbd850;
        }

        .submit{
          margin-left: 10px;

          &:disabled{
            color: #333;
            background-color: #ccc;
          }
        }
      }
    }
  }
</style>
